<echo-nx-table-item-list [fields]="fields" [items]="items | async" [selectable]="false" class="marlenka-item-list">
    <ng-template echoNxTableKey="delete-cell" let-item>
        <button mat-icon-button (click)="remove.emit(item)">
            <mat-icon style="color: #ab0e0e;">delete_forever</mat-icon>
        </button>
    </ng-template>
</echo-nx-table-item-list>
